import { useEffect, useState } from "react";
import { BACKEND_URL } from "@/lib/api";

let promise = null;
const load = () => {
  if (!promise) promise = fetch(`${BACKEND_URL}/api/google-reviews`).then((r) => (r.ok ? r.json() : null)).then((d) => (d?.available ? d : null)).catch(() => null);
  return promise;
};

export const useGoogleReviews = () => {
  const [g, setG] = useState(null);
  useEffect(() => { let on = true; load().then((d) => on && d && setG(d)); return () => { on = false; }; }, []);
  return g;
};
